import logo from '../assets/bt_logoA.png';
import { db } from '../data/firebase';
import { collection, onSnapshot, query} from "firebase/firestore"
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { ConfigsContext } from './ConfigsContext';
import { useEffect } from "react";

let orders = 0;

export default function Header({user})
{
  const { configs, setConfigs } = useContext(ConfigsContext);
  

  useEffect(() =>
    {
    if (!user)
      {
        return (
          <div id='main-bg'>
        <p className="tab-button"> loading</p>
        </div>
        )
      }

    const q = query(collection(db, "users", user.uid, "dimensions"));
    const unsubscribe = onSnapshot(q, (snapshot) => 
    {
      const list = snapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));
      setConfigs(list);
    });

    return () => unsubscribe();
  }, [setConfigs]);

  orders = configs.length;


  return(
  <header id='main-header' className="App-header">
      
      <nav>
        <Link to='/'>
        <section>
        <img 
        alt='Logo'
        src={logo} 
        className="App-logo1" 
        style={{cursor: 'pointer'}}/>
        </section>
        </Link>
      </nav>

      <nav>
        <Link to ='/ship'>
        <button className='header-button' style={{cursor: 'pointer'}}>Ship</button>
        </Link>
      </nav>
      <nav>
        <Link to ='/drive'>
        <button className='header-button' style={{cursor: 'pointer'}}>Drive</button>
        </Link>
      </nav>
      <nav>
        <Link to='/order'>
        <button className='header-button' style={{cursor: 'pointer'}}>Orders: {orders}</button>
        </Link>
      </nav>
    </header>
    
  
  );
}
